// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UserAvatar_wrapper__mziAc","icon":"UserAvatar_icon__78j57","image":"UserAvatar_image__CgCbo"};